export enum HEATMAP_PARAM_NAMES {
  URL = 'url',
  MATCH = 'match',
  DEVICE = 'device',
  TYPE = 'type',
}
